import {AsyncPipe, DatePipe, NgClass, TitleCasePipe}                                                                                                                                    from '@angular/common';
import {AfterViewInit, Component, inject}                                                                                                                                               from '@angular/core';
import {foodAnalysisNutritionDetailDict, foodAnalysisNutritionDetailKeys, FoodAnalysisRatingDict, FoodAnalysisTotalsDict, foodAnalysisTotalsKeys, FoodRecordLogIntf, FoodRecordSumIntf} from '@djsharkk/logr-types';
import {DataFoodService}                                                                                                                                                                from '../../../../../../../logr-services/data/data-fire/data-food.service';
import {MenuBaseService}                                                                                                                                                                from '../../../../../utils/menu-base.service';
import {MenuCrudPanelContentBase}                                                                                                                                                       from '../../menu-crud-panel-content-base';

@Component({
			   selector   : 'app-menu-crud-panel-food-bot',
			   imports    : [
				   AsyncPipe,
				   DatePipe,
				   TitleCasePipe,
				   NgClass
			   ],
			   templateUrl: './menu-crud-panel-food-bot.component.html',
			   styleUrl   : './menu-crud-panel-food-bot.component.css'
		   })
export class MenuCrudPanelFoodBotComponent extends MenuCrudPanelContentBase<FoodRecordLogIntf, FoodRecordSumIntf> implements AfterViewInit {
	svcDataFood = inject(DataFoodService);
	svcMenuBase = inject(MenuBaseService);

	selectedRecord?: FoodRecordLogIntf;

	constructor() {
		super('food', false);
	}


	public ngAfterViewInit() {

	}

	protected readonly foodAnalysisNutritionDetailDict = foodAnalysisNutritionDetailDict;
	protected readonly foodAnalysisNutritionDetailKeys = foodAnalysisNutritionDetailKeys;
	protected readonly FoodAnalysisRatingDict = FoodAnalysisRatingDict;
	protected readonly foodAnalysisTotalsKeys = foodAnalysisTotalsKeys;
	protected readonly foodAnalysisTotalsDict = FoodAnalysisTotalsDict;
}
